module.exports = __webpack_public_path__ + "img/POAM.c7abe600.jpg";